interface Route {
  path: string;
  name: string;
}

interface Routes {
  [key: string]: Route;
}

export const routeConfigs: Routes = {
  login: {
    path: '/login',
    name: 'Login',
  },
  signUp: {
    path: '/sign-up',
    name: 'Sign-Up',
  },
  forgotPassword: {
    path: '/forgot-password',
    name: 'Forgot Password',
  },
  resetPassword: {
    path: '/reset-password',
    name: 'Reset Password',
  },
  buy: {
    path: '/',
    name: 'Buy',
  },
  reports: {
    path: '/reports',
    name: 'Reports',
  },
  buyHistory: {
    path: '/buy-history',
    name: 'Buy History',
  },
  sellHistory: {
    path: '/sell-history',
    name: 'Sell History',
  },
  openOrders: {
    path: '/open-orders',
    name: 'Open Orders',
  },
  profile: {
    path: '/profile',
    name: 'Profile'
  },
  pharmacyProfile: {
    path: '/pharmacy-profile',
    name: 'Pharmacy Profile'
  },
  bankAccount: {
    path: '/bank-account',
    name: 'Bank Account'
  },
  pharmacies: {
    path: '/pharmacies',
    name: 'Pharmacies'
  },
  pharmacy: {
    path: '/pharmacies/:id',
    name: 'Pharmacy'
  },
  postings: {
    path: '/postings',
    name: 'Postings'
  },
  sales: {
    path: '/sales',
    name: 'Sales'
  },
  orders: {
    path: '/orders',
    name: 'Orders'
  },
  sell: {
    path: '/sell',
    name: 'Sell'
  },
  wishlist: {
    path: '/wishlist',
    name: 'Wishlist'
  },
  newWishlistItem: {
    path: '/wishlist/new',
    name: 'New Wishlist Item'
  },
  newSellItem: {
    path: '/new-sell',
    name: 'New Sell'
  },
  editSellItem: {
    path: '/sell/:id',
    name: 'Edit Sell'
  },
  dashboard: {
    path: '/dashboard',
    name: 'Dashboard'
  },
  vacationMode: {
    path: '/vacation-mode',
    name: 'Vacation Mode'
  },
  checkout: {
    path: '/checkout',
    name: 'Checkout'
  },
  sellerListings: {
    path: '/seller-listings/:sellerUserId',
    name: 'Seller listings',
  },
  users: {
    path: '/users',
    name: 'Users'
  },
  addUser: {
    path: '/users/add',
    name: 'add User'
  },
  editUser: {
    path: '/users/:id',
    name: 'edit User'
  },
};


